import classes from "./ChooseStudio.module.css";
import React, { useEffect, useState } from "react";
import { useServiceErstellen } from "../../../store/serviceErstellenStore";
import { useFetchStudiosForService } from "../../../hooks/useFetchStudiosForService";
import { useNavigate } from "react-router-dom";
import { useFromHash } from "../../../hooks/useFromHash";
import ErrorMessage from "../../../components/StudioErstellen/ErrorMessage";

export const ChooseStudio = ({ validate, userID }) => {
    const navigate = useNavigate();
    const { getInternalLinkProps } = useFromHash();
    const { serviceData, updateServiceData } = useServiceErstellen();
    const { studios, loading: studiosLoading, error: studiosError } = useFetchStudiosForService(userID);

    const [errors, setErrors] = useState({
        selectedStudioId: ""
    });

    const handleOptionChange = (studioId) => {
        updateServiceData('selectedStudioId', studioId);
    };
    
    const handleAddStudioClick = () => {
    const linkProps = getInternalLinkProps('/studio-erstellen');
        navigate(linkProps.to, { state: linkProps.state });
    };

    const handleValidation = () => {
        let isValid = true;
        const newErrors = {
            selectedStudioId: ""
        };

        if (!serviceData?.selectedStudioId) {
            newErrors.selectedStudioId = "Du musst ein Studio auswählen.";
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    useEffect(() => {
        validate.current = handleValidation;
    }, [validate, serviceData?.selectedStudioId]);

    return (
        <div className={classes.chooseStudio}>
            <header className={classes.header}>
                <h2 className="titleSemibold">Wo soll dein Service angeboten werden?</h2>
                <p className="slimRegularLargeText" style={{color: "var(--dark-grey-3)"}}>Du kannst kreative Services aktuell nur zusammen mit einem Studio anbieten.</p>
            </header>
            {studiosLoading ? <div>Lade deine Studios...</div> : studiosError ? <div>Fehler beim Laden deiner Studios: {studiosError.message}</div> : (
            <div className={classes.studiosList}>
                {studios?.map((studio) => (
                    <div 
                        key={studio.id} 
                        className={classes.option}
                        onClick={() => handleOptionChange(studio.id)}
                    >   
                        <div className={classes.studioInfo}>
                            <div className={classes.studioImage}>
                                <img src={studio.image} alt={studio.StudioName} />
                            </div>
                            <div 
                                className={classes.containerLabels}
                            >
                                <label style={{marginBottom: "6px", wordBreak: "break-word"}} className="mediumLarge">{studio.StudioName}</label>
                                <label className={`${classes.label} slimRegularSmallText`}>{studio.displayLocation}</label>
                            </div>
                        </div>
                        <input
                            className={classes.inputs}
                            type="checkbox"
                            id={studio.id}
                            name="studioType"
                            value={studio.id}
                            checked={serviceData?.selectedStudioId === studio.id}
                            onChange={() => handleOptionChange(studio.id)}    
                        />
                    </div>
                ))}
                <div onClick={handleAddStudioClick} className={classes.addStudioButton}>
                    <span className={classes.addStudioButtonText}>
                        Neues Studio erstellen
                        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
                            <path fillRule="evenodd" clipRule="evenodd" d="M16.0469 8.57858H0.046875V7.50226H16.0469V8.57858Z" fill="#1F1F1F"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.58121 0.046875V16.0469H7.50489V0.046875H8.58121Z" fill="#1F1F1F"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M16.0469 8.57858H0.046875V7.50226H16.0469V8.57858Z" stroke="black" strokeWidth="0.1" strokeMiterlimit="10"/>
                            <path fillRule="evenodd" clipRule="evenodd" d="M8.58121 0.046875V16.0469H7.50489V0.046875H8.58121Z" stroke="black" strokeWidth="0.1" strokeMiterlimit="10"/>
                        </svg>
                    </span>
                </div>
                {errors.selectedStudioId && <ErrorMessage>{errors.selectedStudioId}</ErrorMessage>}
            </div>
            )}
        </div>
    );
};

export default ChooseStudio;
